import React from 'react';
import { motion } from 'framer-motion';
import './HamburgerButton.css';

interface HamburgerButtonProps {
  isOpen: boolean;
  onClick: () => void;
  className?: string;
  'aria-label'?: string;
}

const HamburgerButton: React.FC<HamburgerButtonProps> = ({
  isOpen,
  onClick,
  className = '',
  'aria-label': ariaLabel = 'Toggle navigation menu'
}) => {
  return (
    <motion.button
      className={`hamburger-button ${className} ${isOpen ? 'open' : ''}`}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-expanded={isOpen}
      aria-controls="mobile-navigation-menu"
      type="button"
      whileTap={{ scale: 0.95 }}
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.15, ease: "easeInOut" }}
    >
      <div className="hamburger-icon" aria-hidden="true">
        <motion.span
          className="hamburger-line hamburger-line-1"
          animate={{
            rotate: isOpen ? 45 : 0,
            y: isOpen ? 8 : 0,
          }}
          transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
        />
        <motion.span
          className="hamburger-line hamburger-line-2"
          animate={{
            opacity: isOpen ? 0 : 1,
            x: isOpen ? 20 : 0,
          }}
          transition={{ duration: 0.2, ease: [0.4, 0, 0.2, 1] }}
        />
        <motion.span
          className="hamburger-line hamburger-line-3"
          animate={{
            rotate: isOpen ? -45 : 0,
            y: isOpen ? -8 : 0,
          }}
          transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
        />
      </div>
      
      {/* Screen reader text */}
      <span className="sr-only">
        {isOpen ? 'Close navigation menu' : 'Open navigation menu'}
      </span>
    </motion.button>
  );
};

export default HamburgerButton;